import { BookOption, BookOptionName, RoutePath } from "@app/constants";
import { Book } from "@app/types";
import { formatMoneyVN } from "@app/utils/util";
import { Images } from "@assets/images";
import clsx from "clsx";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

type TrendingProps = {
  books: Book[];
};

function Trending({ books }: TrendingProps) {
  const [isShowMore, setIsShowMore] = useState(false);

  const data = !isShowMore ? books.slice(0, 3) : books;

  const handleShowMoreClick = () => {
    setIsShowMore(!isShowMore);
  };

  const navigate = useNavigate();

  const handleItemClick = (book: Book) => {
    navigate(`/${RoutePath.BOOK_DETAIL}/${book.id}`);
  };

  const renderBadge = (book: Book) => {
    if (book.bookOption === BookOption.PURCHASE && book.isAvailable) {
      return "Đã Mua";
    }

    return book.bookOption === BookOption.PURCHASE ? (
      <span>
        {formatMoneyVN(book.price)}
        <span className="underline">đ</span>
      </span>
    ) : (
      BookOptionName[book.bookOption]
    );
  };

  return (
    <div className="w-full p-5 bg-custom-radial-1 rounded-3xl">
      <div className="text-[#171A20] font-[SVN-Gilroy] text-[26px] font-bold">
        Đang Thịnh Hành
      </div>
      <div className="mt-[17px] px-4 grid lg:grid-cols-2 xl:grid-cols-3 gap-7">
        {data.map((book, index) => (
          <div key={book.id} className="flex gap-3 items-center">
            <div className="relative">
              <div
                className={clsx(
                  "absolute z-50 top-0 right-0 px-3 py-[6px] rounded-tr-md rounded-bl-2xl text-sm font-medium font-[SVN-Gilroy] tracking-[0.028px]",
                  {
                    "bg-[#E6FFED] text-[#00A653]":
                      book.bookOption === BookOption.FREE,
                    "bg-[#FFFEE6] text-[#FFD500]":
                      book.bookOption === BookOption.VIP,
                    "bg-[#FFE4D6] text-[#FF7029]":
                      book.bookOption === BookOption.PURCHASE,
                  }
                )}
              >
                {renderBadge(book)}
              </div>
              <div
                className={clsx(
                  "absolute -top-4 -left-4 font-[SVN-Gilroy] text-[32px] font-bold text-white size-16",
                  "flex justify-center items-center rounded-2xl shadow-[0_9.63px_19.25px_0_rgba(0,0,0,0.20)] bg-[#657892]",
                  {
                    "!bg-[#FF7029]": index === 0,
                    "!bg-[#FFD500]": index === 1,
                    "!bg-[#00A653]": index === 2,
                  }
                )}
              >{`#${index + 1}`}</div>
              <img
                className="max-w-[200px] max-h-[300px] min-w-[180px] min-h-[280px] rounded-lg cursor-pointer"
                src={book.thumbnails[0]}
                alt=""
                onClick={() => handleItemClick(book)}
              />
            </div>
            <div className="max-w-[175px]">
              <div
                className="text-[#333B47] font-[SVN-Gilroy] text-lg font-semibold tracking-[0.027px] cursor-pointer"
                onClick={() => handleItemClick(book)}
              >
                {book.name}
              </div>
              <div className="text-[#657892] font-[SVN-Gilroy] text-sm font-medium tracking-[0.028px]">
                {book.author}
              </div>
              <div className="mt-2 flex gap-3">
                <div className="flex items-center gap-1">
                  <div>
                    <img src={Images.HeartGrayIcon.default} alt="" />
                  </div>
                  <div className="text-[#657892] font-[SVN-Gilroy] text-sm font-medium">
                    {book.insight.likeCount ?? 0}
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  <div>
                    <img src={Images.Eye1GrayIcon.default} alt="" />
                  </div>
                  <div className="text-[#657892] font-[SVN-Gilroy] text-sm font-medium">
                    {book.insight.viewCount ?? 0}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-center">
        <button
          className="text-[#5A82D7] mt-5 font-bold font-[SVN-Gilroy] text-sm flex gap-1"
          onClick={handleShowMoreClick}
        >
          <div>{!isShowMore ? "Xem thêm" : "Thu nhỏ"}</div>
          <div>
            <img
              src={
                !isShowMore ? Images.ArrowDown.default : Images.ArrowUp.default
              }
              alt=""
            />
          </div>
        </button>
      </div>
    </div>
  );
}

export default Trending;
